<div class="app-container responsive-container">
  <div class="details-back">
    <button class="btn button-back channels-button"
            (click)="back()"
            translate="BACK"></button>
  </div>

  <cc-box>
    <div class="call-history-list-content" content box>

      <mat-table
        (matSortChange)="sortChange($event)"
        matSort
        [dataSource]="dataSource.data"
        class="integration-imports-table">

        <ng-container matColumnDef="sourceObjectId">
          <mat-header-cell *matHeaderCellDef mat-sort-header="SOURCE_OBJECT_ID">
            {{ 'INTEGRATIONS.HEADERS.SOURCE_OBJECT_ID' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.sourceObjectId }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="msisdn">
          <mat-header-cell *matHeaderCellDef mat-sort-header="MSISDN">
            {{ 'INTEGRATIONS.HEADERS.MSISDN' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
                  <span>{{ element.msisdn }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="reason">
          <mat-header-cell *matHeaderCellDef mat-sort-header="REASON">
            {{ 'INTEGRATIONS.HEADERS.REASON' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.reason }}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="total"
        [pageSize]="paginator.pageSize"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>
  </cc-box>
</div>
